// sagas.ts
import { all } from "redux-saga/effects";
import addressSaga from "./address.saga";
import countrystatesSaga from "./country.saga";
import userSaga from "./user.saga";
import s3uploadSaga from "./s3upload.saga";
import authSaga from "./auth.saga";
import { watchNetworkStatus } from "./network.saga";
// Define sagas
function* rootSaga() {
  yield all([
    // Add your sagas here
    addressSaga(),
    countrystatesSaga(),
    userSaga(),
    s3uploadSaga(),
    authSaga(),
    watchNetworkStatus()
  ]);
}

export default rootSaga;
